export default {
  'basicData': {
    'lastName': '홍',
    'firstName': '길동',
    'lastNameFurigana': '',
    'firstNameFurigana': '',
    'birthYear': '2002',
    'birthMonth': '5',
    'birthDay': '8',
    'sex': '1',
    'postNumber': '12345',
    'address1': '서울시 종로구 xx동',
    'address2': 'xx아파트 xxx동 xx호',
    'addressFurigana': '',
    'tel1': '010',
    'tel2': '1234',
    'tel3': '5678',
    'mobile': '',
    'fax': '',
    'email': 'email@yagish.jp',
    'idPhotoSrc': '/kr/resume/static/img/id-photo-sample.jpg',
    'useContact': [''],
    'contactPostNumber': '',
    'contactAddress1': '',
    'contactAddress2': '',
    'contactAddressFurigana': '',
    'contactCareOf': '',
    'contactTel': '',
    'contactMobile': '',
    'contactFax': '',
    'contactEmail': '',
    'updateDate': ''
  },
  'formatData': {
    'createDate': new Date(),
    'formatId': 'rirekisho',
    'saveName': 'rirekisho',
    'educationalHistories': [
      {
        'year': 2013,
        'month': 2,
        'description': 'XX중학교 졸업',
        'uuid': '4005e384-8ce0-405b-b0f1-dea47be1a4cb'
      },
      {
        'year': 2013,
        'month': 3,
        'description': 'XX고등학교 입학',
        'uuid': 'e193e07f-1cf2-4930-bd52-1065f88c2c4e'
      },
      {
        'year': 2016,
        'month': 2,
        'description': 'XX고등학교 졸업',
        'uuid': '108c84e3-ae50-40e7-90f5-0becc48785b4'
      },
      {
        'year': 2016,
        'month': 3,
        'description': 'XX대학교 입학',
        'uuid': 'ef19cdf2-34f2-4076-a4bd-3381841cf987'
      },
      {
        'year': 2022,
        'month': 2,
        'description': 'XX대학교 졸업',
        'uuid': '99a44d4a-73c6-4440-8247-7bf14ec960bd'
      }
    ],
    'jobHistories': [
      {
        'year': '2023',
        'month': '5',
        'description': '주식회사 XXX입사',
        'uuid': '636850ef-d6c0-4c22-91b7-bc2508c76fe4'
      },
      {
        'year': '',
        'month': '',
        'description': '재직중',
        'uuid': '286a59ea-e324-40e5-a09d-eea79751ba54'
      }
    ],
    'licenseHistories': [
      {
        'year': '2013',
        'month': '4',
        'description': '컴퓨터활용자격증',
        'uuid': 'a2e09439-2c36-4981-a643-2b0f7adab257'
      },
      {
        'year': '2014',
        'month': '6',
        'description': 'TOEIC 취득 700점',
        'uuid': 'd6d648f8-30dd-4c09-9367-036416723c1c'
      }
    ],
    'commuteHours': '0',
    'commuteMinutes': '40',
    'commuteDescription': '자차소유',
    'spouseNumber': '0',
    'hasSpouse': false,
    'underDutyToSupport': false,
    'reason': '저는 OOOO 년 OO월 OO일에 서울 OO에서 2남 1녀 중 막내로 태어났습니다. 아버지께서는 늘 가훈처럼 이런 말씀을 하셨습니다. 노력 없이 얻을 수 있는 건 없다”라고 하셨습니다. 그리고 실제로 성실하게 노력하시는 아버지의 삶을 보면서 자랐습니다. 어머니께서는 이해심이 많으셨습니다. 어머니는 바다 같은 이해심으로 자식들을 바르게 가르쳤습니다. 이런 가정환경으로 저는 어떤 일이든 노력하는 성실함과 사람을 함부로 평가하지 않고 이해하려는 마음으로 대하게 되었습니다. 앞으로 oo회사 oo직무에 “노력 없이 어떤 것도 얻을 수 없다”는 신념으로 주어진 일에 임하고 싶습니다.',
    'request': '어려운 사람에게 먼저 손 내밀 줄 아는 ‘따뜻한 마음’이 저의 가장 큰 장점입니다. 영어 통역 담당으로 참가했던 국제 보트 전시회에서 곤란을 겪고 있는 바이어에게 먼저 다가가 도움을 준 경험이 있습니다.',
    'reason2': '군대를 제대하고 ○○전문대 건축과에 복학했습니다. 학교를 다니면서 건축산업기사 자격증을 땄고 스터디 회장을 하면서 건축을 더 공부하게 되었고 그 때문인지 2년 동안 장학금을 받았고 졸업할 때는 우수상을 받았습니다. 건축에 대해 더 공부하고 싶어 광주에 있는 ○○대학교에 편입을 하여 건축기사 자격증을 땄지만 관심 있어 하는 시공보다는 설계위주의 수업 방식 때문에 수업에 소홀하여 성적은 좋지 않았지만 시공 지식은 누구에게도 뒤지지 않는다고 자부합니다.',
    'reason3': 'OO은 제가 경험한 것들을 활용할 수 있는 분야이기에, 저의 능력을 발휘하여 충분히 회사에 이바지할 수 있다고 생각하여 복합기 및 솔루션 기술영업에 지원하게 되었습니다. 학창시절 OOOOOO안과에서 스캔 및 사무보조 아르바이트를 담당하였습니다. 하루 100~200명분의 검사와 수술고객의 차트를 스캔하는 업무로 복합기의 사용빈도가 굉장히 높았고, OO의 제품을 비롯하여 다양한 회사의 제품을 사용해 보았기 때문에 우리 제품과 타사제품을 비교하여 고객에게 더 나은 상품 제안이 가능하다고 생각합니다.',
    'reason4': '저는 OOOO 프로젝트를 통해 프로젝트 완료보고 예상 기일보다 O 개월이라는 시간을 단축할 수 있었던 경험을 가지고 있습니다. 불필요한 시간 낭비를 줄이고, 중요한 부분에 집중한 결과입니다. 변화하는 OOO 시장에서 개선점을 찾고 효율성 증대를 통한 이익 창출의 노력은 끊임없이 진행되어야 할 것입니다. OOOO 업무 담당자로서의 책임감을 가지고 기업 OOO 의 매출 향상에 일조할 수 있도록 하겠습니다.',
    'updateDate': ''
  }
}
